export interface Group {
    group_id: string;
    name: string | null;
    day: string | null;
    local_time: string | null; // HH:mm
    timezone: string | null;
}

export interface GroupsPayload {
    meeting: Group[];
    intergroup: Group[];
    region: Group[];
    is_production: boolean;
}

export enum DonorTypes {
    INDIVIDUAL = 'Individual',
    MEETING = 'Meeting',
    INTERGROUP = 'Intergroup',
    REGION = 'Region',
}

declare global {
    interface Window {
        wsoDonationFormData: GroupsPayload | undefined;
    }
}